












































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import Editor from '@/components/Editor/editor.vue'
import { getNoticeDetail, modifyNotice } from '@/api/content/content-notice/notice'
import { stringToDate } from '@/utils/tool'

@Component({
  name: 'NoticeEdit',
  components: {
    Editor
  }
})
export default class extends mixins(DisplayMixin) {
  params: any = {
    id: 0,
    title: '',
    language: '',
    type: '',
    status: '',
    link: '',
    displayDateStart: '',
    displayDateEnd: '',
    content: ''
  }
  displayRange = ['', '']
  typeMap: string[] = ['PC官网', 'iOS官网', '移动端', 'iOS', '安卓官网']
  ready: boolean = false

  created() {
    this.getDetail()
  }

  async getDetail() {
    const query = this.$route.query
    let id = parseInt(query.id as string) || 0
    if (!id) return (this.ready = true)
    const res: any = await getNoticeDetail({ id })
    const d: any = res.data
    this.params = d
    this.ready = true
    this.displayRange = [d.displayDateStart, d.displayDateEnd]
    console.log(d)
  }

  checkParams() {
    const p: any = { ...this.params }
    const checkList = ['type', 'title', 'content', 'language', 'displayDateStart', 'displayDateEnd', 'status']
    const warnList = ['通告类型', '标题', '内容', '语言', '开始时间', '结束时间', '使用状态']
    p.type = p.type.toString()
    p.status = p.status.toString()
    for (const i in checkList) {
      if (!p[checkList[i]]) return this.$message.warning('请设置' + warnList[i])
    }
    return false
  }

  async handeSubmit(type: 'save' | 'commit') {
    const pass = this.checkParams()
    if (pass) return false
    const res: any = await modifyNotice(this.params)
    if (~~res.status.code === 0) {
      this['$message'].success('操作成功')
      // this.getDetail()
      history.go(-1)
    } else {
      this['$message'].success(res.status.message)
    }
  }

  onChange(val: any) {
    // console.log(stringToDate(val[0]))
    if (val && val.length) {
      this.params.displayDateStart = stringToDate(val[0])
      this.params.displayDateEnd = stringToDate(val[1])
    }
  }
}
